var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ rtl: _vm.$i18n.locale === 'AR' },attrs:{"id":"app"}},[_c('HomeHead'),_c('Home'),_c('Accept')],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }